import { render, staticRenderFns } from "./PPVVibBl.vue?vue&type=template&id=57906f04&scoped=true&"
import script from "./PPVVibBl.vue?vue&type=script&lang=js&"
export * from "./PPVVibBl.vue?vue&type=script&lang=js&"
import style0 from "./PPVVibBl.vue?vue&type=style&index=0&id=57906f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57906f04",
  null
  
)

/* custom blocks */
import block0 from "./PPVVibBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports